module.exports = __webpack_public_path__ + "img/img_inner_heart.154413ec.png";